/**
 * Qrchestration `Sequence Types` decides in which sequence the given GQL call is resolved.
 *
 * Paths:
 * `Primary` path: means for the `GQL call` fired from the `view`, we want to pass it to the server(BFF in our case) with or without request modification.
 * `CUSTOM` path: means for the `GQL call` fired from the `view`, we don't want to pass it to the server(BFF in our case) and do some custom handling for it.
 *
 * Both of the above path can be combined in different ways to create different orchestration sequences.
 */
var SequenceTypes = /*#__PURE__*/function (SequenceTypes) {
  SequenceTypes["PRIMARY_ONLY"] = "PRIMARY_ONLY";
  SequenceTypes["PRIMARY_FIRST"] = "PRIMARY_FIRST";
  SequenceTypes["CUSTOM_FIRST"] = "CUSTOM_FIRST";
  SequenceTypes["PARALLEL"] = "PARALLEL";
  SequenceTypes["CUSTOM_ONLY"] = "CUSTOM_ONLY";
  return SequenceTypes;
}(SequenceTypes || {});
/**
 * IOrchestratorHandler:
 * Defines how `primary` and `custom` datas are fetched and how it is stitched together.
 */
var Path = /*#__PURE__*/function (Path) {
  Path["PRIMARY"] = "PRIMARY";
  Path["CUSTOM"] = "CUSTOM";
  return Path;
}(Path || {});
export { Path, SequenceTypes };